import { offersConstants } from '../../constants/offers';
import { find } from 'lodash';

export const setGeoToOffers = store => next => action => {
  if (action.type === offersConstants.SET_OFFERS_LIST_SUCCESS) {
    if (action.offers !== undefined) {
      const state = store.getState();
      const countries = state.app.globalSettings.countries;
      const offers = action.offers;

      for (let i = 0; i < offers.length; i++) {
        let geo = offers[i].geo;
        let notCountrys;

        if (offers[i].offer_geo && offers[i].offer_geo.not_countrys) {
          notCountrys = offers[i].offer_geo.not_countrys;
        } else {
          notCountrys = [];
        };

        let countriesList = [];
        let forbiddenGeo = [];        

        for (let j = 0; j < geo.length; j++) {
          const result = _.find(countries, { id: geo[j] });

          if (result !== undefined) {
            countriesList.push(result.title);
          }
        }

        for (let k = 0; k < notCountrys.length; k++) {
          const result = _.find(countries, { id: notCountrys[k] });

          if (result !== undefined) {
            forbiddenGeo.push(result.title);
          }
        }

        offers[i] = { ...offers[i], countriesList, forbiddenGeo };
      }
    }
  }

  if (action.type === offersConstants.SET_OFFER_SUCCESS) {
    if (action.offer !== undefined) {
      const state = store.getState();
      const countries = state.app.globalSettings.countries;
      const offer = action.offer;
      const geo = offer.geo;
      let notCountrys;

      if (offer.offer_geo && offer.offer_geo.not_countrys) {
        notCountrys = offer.offer_geo.not_countrys;
      } else {
        notCountrys = [];
      };

      let countriesList = [];
      let forbiddenGeo = [];

      for (let i = 0; i < geo.length; i++) {
        const result = _.find(countries, { id: geo[i] });

        if (result !== undefined) {
          countriesList.push(result.title);
        }
      }

      for (let k = 0; k < notCountrys.length; k++) {
        const result = _.find(countries, { id: notCountrys[k] });

        if (result !== undefined) {
          forbiddenGeo.push(result.title);
        }
      }

      action.offer = { ...offer, countriesList, forbiddenGeo };
    }
  }

  return next(action);
};
